<script>
  export let model;
  import StepperHeadline from "../stepper/StepperHeadline.svelte";
</script>

<StepperHeadline>
  <h1>
    Thanks for your <span class="text-red">feedback</span>!
  </h1>
  <p>
    It helps us figure out what GETitOUT needs to do to really help you out.
  </p>
</StepperHeadline>
